import { cloneDeep, isEmpty } from 'lodash';

import { EntitledTabs, useEntitledTabsGuard } from 'common/hooks/useEntitledTabsGuard';
import {
  ExploreOrganizationTabType,
  ExploreOrganizationTabsConfig,
} from 'features/org-root/config/explore-organization-tabs.config';
import { useGetSearchResultsCount } from 'features/search/hooks/useGetSearchResultCounts';
import { EXPLORE_TABS } from '../explore.constants';

export const useExploreTabs = (tabs: ExploreOrganizationTabType[] = []) => {
  const guardEntitledTabs = useEntitledTabsGuard();
  const response = useGetSearchResultsCount({ enabled: !!tabs.length });
  let exploreTabs = cloneDeep(EXPLORE_TABS);

  if (!isEmpty(response.data)) {
    const {
      profiles,
      opportunities,
      praises,
      companyUpdates,
      organizationEvents,
      videos,
      winLists,
      activities,
    } = response.data;

    exploreTabs = [
      { ...ExploreOrganizationTabsConfig.PEOPLE, badgeLabel: profiles },
      { ...ExploreOrganizationTabsConfig.OPPORTUNITIES, badgeLabel: opportunities },
      { ...ExploreOrganizationTabsConfig.PRAISE, badgeLabel: praises },
      { ...ExploreOrganizationTabsConfig.COMPANY_UPDATES, badgeLabel: companyUpdates },
      { ...ExploreOrganizationTabsConfig.EVENTS, badgeLabel: organizationEvents },
      { ...ExploreOrganizationTabsConfig.VIDEOS, badgeLabel: videos },
      { ...ExploreOrganizationTabsConfig.WIN_LIST, badgeLabel: winLists },
      { ...ExploreOrganizationTabsConfig.ACTIVITIES, badgeLabel: activities },
    ] as ExploreOrganizationTabType[];
  }

  exploreTabs = guardEntitledTabs(
    exploreTabs as EntitledTabs[],
  ) as ExploreOrganizationTabType[];

  return {
    exploreTabs,
  };
};
